import { z } from 'zod';
import {
    type NodeSocketCfg,
    baseNodeCfgSchema,
} from './base-node';

function mqttSubscribeNodeCfgPreprocess (value: unknown) {
    const maybeNodeParseResult = baseNodeCfgSchema.safeParse(value);
    if (maybeNodeParseResult.success) {
        const nodeCfg = maybeNodeParseResult.data;
        if (nodeCfg.kind === 'mqttSubscribe') {
            // move topic from controlValues to socketDefaults
            const topicSetInControlValues = typeof nodeCfg.controlValues?.topic === 'string' && nodeCfg.controlValues?.topic;
            const topicSetInSocketDefaults = nodeCfg.socketDefaults?.inputs?.topic;
            if (topicSetInControlValues && !topicSetInSocketDefaults) {
                nodeCfg.socketDefaults = {
                    ...nodeCfg.socketDefaults,
                    inputs: {
                        ...nodeCfg.socketDefaults?.inputs,
                        topic: nodeCfg.controlValues?.topic,
                    },
                };
            }
        }
        return nodeCfg;
    } else {
        return value; // let the next schema produce the error
    }
}

const mqttSubscribeNodeCfgSchema = baseNodeCfgSchema.extend({
    controlValues: z.object({
        autoSubscribe: z.boolean().default(true),
        qos: z.union([
            z.literal(0),
            z.literal(1),
            z.literal(2),
        ]),
    }),
    kind: z.literal('mqttSubscribe'),
});
export type MqttSubscribeNodeCfgSchema = z.infer<typeof mqttSubscribeNodeCfgSchema>;

const mqttSubscribeNodeCfgSchemaPreprocessed = z.preprocess(mqttSubscribeNodeCfgPreprocess, mqttSubscribeNodeCfgSchema) as z.ZodType<MqttSubscribeNodeCfgSchema>;
export { mqttSubscribeNodeCfgSchemaPreprocessed as mqttSubscribeNodeCfgSchema };

export const mqttSubscribeNodeSocketCfg = {
    controlSockets: {
        inputs: () => ({ resubscribe: 'event' }),
        outputs: () => ({ event: 'event' }),
    },
    dataSockets: {
        inputs: () => ({ topic: 'string' }),
        outputs: () => ({ payload: 'string' }),
    },
} satisfies NodeSocketCfg<MqttSubscribeNodeCfgSchema>;
